"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUser = void 0;
const app_1 = require("@koopajs/app");
const react_redux_1 = require("react-redux");
const useUser = () => {
    const dispatchUpdateUser = app_1.Operations.Me.update(react_redux_1.useDispatch());
    const setUser = async (attributes) => {
        return await dispatchUpdateUser(attributes);
    };
    const user = react_redux_1.useSelector(app_1.Selectors.Me.get);
    const { errorMessage, isProcessing } = react_redux_1.useSelector(app_1.Selectors.Me.state);
    return {
        user,
        setUser,
        errorMessage,
        isProcessing
    };
};
exports.useUser = useUser;
//# sourceMappingURL=useUser.js.map